<template>
    <v-select
        v-if="isEditable"
        ref="select"
        key="enable"
        v-model="selectData"
        :items="itemsData"
        :rules="rulesData"
        :disabled="isDisabled"
        :item-text="itemTextData"
        :item-value="itemValueData"
        :append-icon="appendIconData"
        :clearable="isClearable"
        :placeholder="placeholder"
        :label="label"
        :multiple="multiple"
        :no-data-text="noDataText"
        :chips="chips"
        :deletable-chips="deletableChips"
        :suffix="suffix"
        class="text-body-2"
        dense
        @focus="e => $emit('focus', e)"
        @blur="e => $emit('blur', e)"
        @click:clear="outOfFocus"
    >
        <template v-if="hasSelectionSlot" v-slot:selection="props">
            <slot name="selection" v-bind="props" />
        </template>
    </v-select>
    <v-flex v-else key="disable" class="label-for-input-form text-caption">
        <label v-text="labelText" />
    </v-flex>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'SelectLabel',
})
export default class SelectLabel extends Vue {
    @Prop({ type: [String, Number, Array], default: '' }) value: string | number | Array<string> | Array<number>;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: () => [] }) rules: Array<any>;
    @Prop({ default: () => [] }) items: Array<any>;
    @Prop({ default: '' }) itemValue: string;
    @Prop({ default: '' }) itemText: string;
    @Prop({ default: '' }) appendIcon: string;
    @Prop({ default: false }) clearable: boolean;
    @Prop({ default: undefined }) placeholder: string;
    @Prop({ default: undefined }) label: string;
    @Prop({ default: undefined }) readonly multiple?: boolean;
    @Prop({ default: undefined }) noDataText: string;
    @Prop({ default: false }) chips: boolean;
    @Prop({ default: false }) deletableChips: boolean;
    @Prop({ default: undefined }) readonly suffix?: string;

    get selectData(): string | number | Array<string> | Array<number> {
        return this.value;
    }
    set selectData(newValue: string | number | Array<string> | Array<number>) {
        this.$emit('input', newValue);
    }

    get isEditable(): boolean {
        return this.editable;
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get rulesData(): Array<any> {
        return this.rules;
    }
    get itemsData(): Array<any> {
        return this.items;
    }
    get itemValueData(): string {
        return this.itemValue;
    }
    get itemTextData(): string {
        return this.itemText;
    }
    get appendIconData(): string {
        return this.appendIcon;
    }
    get isClearable(): boolean {
        return this.clearable;
    }
    get labelText(): string {
        const matchArray = this.itemsData.filter(item => item[this.itemValueData] === this.selectData);

        if (matchArray.length < 1) return '';
        return matchArray[0][this.itemTextData];
    }
    get hasSelectionSlot(): boolean {
        const slots = this.$scopedSlots;
        if (!slots) {
            return false;
        }
        return Object.keys(slots).includes('selection');
    }

    outOfFocus(val: boolean): void {
        // 選択項目をクリアした場合はフォーカスをはずすようにする
        // clearableが押された場合にlabelが元に戻らないため
        (this as any).$refs['select'].isFocused = false;
    }
    reset(): void {
        (this as any).$refs['select'].reset();
    }
}
</script>

<style lang="scss" scoped>
:deep(.v-list--dense .v-list-item .v-list-item__title) {
    font-size: 0.75rem;
}
:deep(.v-select__slot) {
    padding-bottom: 5px;
}
</style>
